// extracted by mini-css-extract-plugin
export default {"container":"BrandInfo_container__0cCse"};